import { HttpService } from '@/infra/http'

export type TGetEmpreendimentosDisponiveisResponse = Array<{
  idExterno: string
  nome: string
}>

export class GetEmpreendimentosDisponiveisService extends HttpService {
  execute = async (apenasFuturo?: boolean) => {
    return this.http.get<TGetEmpreendimentosDisponiveisResponse>(`api/v2/Empreendimento/disponiveis`, {
      params: {
        apenasFuturo,
      },
    })
  }
}
